import type { ListDataStreams200Item } from "@/api/orval/generated/schemas";

/** Replaces mergeResolvedStreams on parked/data-viewer-followup-v2. */
export function selectStreams(
    zoneStreams: readonly ListDataStreams200Item[],
    orgStreams: readonly ListDataStreams200Item[],
    addedIds: readonly number[],
): ListDataStreams200Item[] {
    const orgById = new Map(orgStreams.map((stream) => [stream.id, stream]));
    const seen = new Set(zoneStreams.map((stream) => stream.id));

    const added = addedIds.flatMap((id) => {
        const stream = orgById.get(id);
        if (!stream || seen.has(id)) return [];
        seen.add(id);
        return [stream];
    });

    return [...zoneStreams, ...added];
}
